import { render, staticRenderFns } from "./orglist.vue?vue&type=template&id=077992e7&scoped=true&"
import script from "./orglist.vue?vue&type=script&lang=js&"
export * from "./orglist.vue?vue&type=script&lang=js&"
import style0 from "./orglist.vue?vue&type=style&index=0&id=077992e7&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "077992e7",
  null
  
)

export default component.exports